"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Form = /*#__PURE__*/function (_React$Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "checkButtonLabel", function (label) {
      var affectedPawns = Fortress.user.pawns.filter(function (r) {
        return r.name !== 'Guest';
      });
      var rows = [];
      if (label.toLowerCase().indexOf('password') !== -1) {
        affectedPawns.forEach(function (elem, index) {
          rows.push(/*#__PURE__*/_react["default"].createElement("div", {
            key: index
          }, elem.name));
        });
      }
      return rows;
    });
    return _this;
  }
  _inherits(Form, _React$Component);
  return _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        buttonLabel = _this$props.buttonLabel;
      var showList = this.checkButtonLabel(this.props.buttonLabel);
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.props.fieldDefs.map(function (f) {
        if (f.data_type === 'string') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: "mb-3 "
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "text",
            className: 'form-control ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'is-invalid' : ''),
            autoComplete: f.autoComplete
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]), {
            disabled: f.disabled
          })), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "invalid-feedback"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'password') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: "mb-3 "
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "password",
            className: 'form-control ' + +(_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'is-invalid' : ''),
            autoComplete: f.autoComplete
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]))), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "invalid-feedback"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'boolean') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: "mb-3 "
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "checkbox",
            className: 'form-check ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'is-invalid' : '')
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]))), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "invalid-feedback"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'enum') {
          var values = f.values;
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: "mb-3 "
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "form-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]), {
            className: 'form-select ' + +(_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'is-invalid' : ''),
            style: {
              width: 'auto'
            }
          }), values.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              value: item.value,
              key: item.value
            }, item.name);
          }), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "invalid-feedback"
          }, _this2.props.fields[f.handle].error)));
        }
        return /*#__PURE__*/_react["default"].createElement("div", null);
      })), showList.length !== 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          fontWeight: 'bold'
        }
      }, "Your password will be updated for the following roles: "), /*#__PURE__*/_react["default"].createElement("div", null, showList)), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        title: buttonLabel,
        isLoading: submitting,
        onClick: handleSubmit
      })));
    }
  }]);
}(_react["default"].Component); // function mapStateToProps(state, ownProps) {
//     console.log(ownProps);
//     return {
//         initialValues: {}
//     }
// }
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  fieldDefs: _propTypes["default"].array.isRequired,
  pawn: _propTypes["default"].object.isRequired,
  initialValues: _propTypes["default"].object,
  buttonLabel: _propTypes["default"].string.isRequired
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  // fields,
  // remember_me = false,
  // because otherwise react warns about controlled/uncontrolled component
  // initialValues: {},
})(Form);